(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {

    const modal = document.getElementById('adlYmmModal');
    if (!modal) return;

    const closeBtn = modal.querySelector('.adl-ymm-close');

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    function bindTriggers() {
      document.querySelectorAll('.cd-popup-trigger').forEach(function (btn) {
        if (btn.dataset.adlBound === '1') return;

        btn.dataset.adlBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openModal();
        });
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    bindTriggers();
    new MutationObserver(bindTriggers).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

  });

})();